import { resolveSource } from './resolveSource.js';

export const buildUserFeedbackPayload = ({
  rating,
  text,
  profileId,
  isMobileApp,
  platformId,
  isBenefitActive,
  partnerData,
  domainRegion,
  isTestEnvironment
}) => {
  const tags = [
    'direct-customer',
    isMobileApp ? 'APP' : 'KZ',
    isBenefitActive ? 'B2B' : 'B2C'
  ];

  if (isTestEnvironment) {
    tags.push('test');
  }

  const metadata = {
    domain_region: domainRegion
  };

  if (isBenefitActive && partnerData) {
    metadata.partner_name = partnerData.name;
    metadata.partner_region = partnerData.region;
  }

  return {
    feedback_type: 'user_feedback',
    profile_id: profileId,
    rating,
    comment: text,
    source: resolveSource(isMobileApp, platformId),
    tags,
    metadata
  };
};
